exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".widget-editor .lollipop .widget-icon {\n  background: url(\"/content/plugin-live-exploratory-viz/lollipop-icon.svg\") no-repeat !important;\n  opacity: 1 !important; }\n\n.widget-editor .lollipop:hover .widget-icon {\n  filter: brightness(0.7); }\n\n.widget-editor .lollipop.active .widget-icon {\n  filter: grayscale(1); }\n", ""]);

